// Module
var code = `
<div class="{{className}}" style="position: absolute; left: {{left}}px; top: {{top}}px; visibility:{{visible?'visible':'hidden'}};" on-mouseover="componentOver" on-mouseout="componentOut" on-mousemove="drag" on-mousedown="dragstart" on-mouseup="dragend">
    
    <img src="{{mainSrc}}" on-click="handleMainImageClick" on-mouseover="onMouseOverMain" on-mouseout="onMouseOutMain" style="cursor: {{mainCursor}};" draggable="false">
    
    <!-- Action Section -->
    {{#if useTextForAction}}
        <div class="tradingView-tool-actionDiv" on-click="handleActionImageClick" on-mouseover="onMouseOverAction" on-mouseout="onMouseOutAction" style="visibility: {{uncollapsed && visible ? 'visible' : 'hidden'}}; cursor: {{actionCursor}}; background-color: {{pricePlateColor}};" contenteditable="true">
            {{actionSectionText}}
        </div>
    {{else}}
        <img class="tradingView-tool-actionImg" src="{{actionSrc}}" on-click="handleActionImageClick" on-mouseover="onMouseOverAction" on-mouseout="onMouseOutAction" style="visibility: {{uncollapsed ? 'visible' : 'hidden'}}; cursor: {{actionCursor}};" draggable="false">
    {{/if}}
    
    <!-- Cancel Button Section -->
    <img class="tradingView-tool-cancelSection" src="{{cancelSrc}}" on-click="handleCancelImageClick" on-mouseover="onMouseOverCancel" on-mouseout="onMouseOutCancel" style="visibility: {{uncollapsed && visible ? 'visible' : 'hidden'}}; cursor: {{closeCursor}};" draggable="false">  
    
    <!-- Price Line -->
    <div class="tradingView-tool-dotted-line" style="left: {{width}}px; width: {{containerWidth-150}}px; border-color: {{priceLineColor}};"></div>

</div>

<!-- Price Plate -->
<div class="tradingView-tool-price-plate" style="top:{{top+4}}px; color:{{priceTextColor}}; background-color:{{pricePlateColor}}; visibility:{{visible?'visible':'hidden'}};">
    {{price}}
</div>`;
// Exports
export default code;